import { render, staticRenderFns } from "./media-manager.html?vue&type=template&id=2a5187b7&scoped=true&external"
import script from "./MediaManager.vue?vue&type=script&lang=js"
export * from "./MediaManager.vue?vue&type=script&lang=js"
import style0 from "./MediaManager.vue?vue&type=style&index=0&id=2a5187b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5187b7",
  null
  
)

export default component.exports